import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove branded loader once React is ready
const loader = document.getElementById("initial-loader");
if (loader) loader.remove();

createRoot(document.getElementById("root")!).render(<App />);
